import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import PromoBanner from "./PromoBanner";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ProductCard from "./ProductCard";

const Destockage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/destockage")
      .then((res) => res.json())
      .then((data) => {
        setProducts(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="page">
      <Helmet>
        <title>Déstockage – Sacs en crochet à prix réduit | Deenzine</title>
        <meta name="description" content="Profite du déstockage Deenzine : sacs en crochet faits main à prix réduit, stocks ultra limités. Quand c'est parti, c'est parti." />
        <link rel="canonical" href="https://www.deenzine.com/destockage" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Deenzine" />
        <meta property="og:locale" content="fr_FR" />
        <meta property="og:url" content="https://www.deenzine.com/destockage" />
        <meta property="og:title" content="Déstockage – Sacs en crochet à prix réduit | Deenzine" />
        <meta property="og:description" content="Sacs en crochet faits main à prix réduit. Stocks limités, profites-en vite !" />
        <meta property="og:image" content="https://www.deenzine.com/images/og-deenzine.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Déstockage Deenzine – Sacs crochet en promo" />
        <meta name="twitter:description" content="Sacs en crochet faits main à prix réduit. Stocks limités !" />
        <meta name="twitter:image" content="https://www.deenzine.com/images/og-deenzine.jpg" />
      </Helmet>

      <PromoBanner />
      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad">
            <div className="badge">⏳ Stocks limités • Jusqu’à épuisement</div>
            <h1 className="h2" style={{ color: "var(--brand)", marginTop: 10 }}>
              Dernières pièces en stock
            </h1>
            <p className="p">
              Modèles disponibles immédiatement. Quand c’est parti, c’est parti.
            </p>
          </div>

          <div style={{ height: 18 }} />

          {loading ? (
            <div className="card cardPad">Chargement…</div>
          ) : products.length === 0 ? (
            <div className="card cardPad">Aucun article en déstockage actuellement.</div>
          ) : (
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 18 }}>
              {products.map((product) => (
                <ProductCard
                  key={product.id}
                  productId={product.id}
                  image={product.image}
                  name={product.name}
                  price={product.price}
                  promo_price={product.promo_price}
                  promo_active={product.promo_active}
                  colors={product.colors}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Destockage;
